import {SvgIcon, SvgIconProps} from '@mui/material'
import React from 'react'

import {ReactComponent as KilnRotaryIconSvg} from '../../assets/icons/KilnRotary.svg'

export const KilnRotaryIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon component={KilnRotaryIconSvg} {...props} />
)
